<template>
  <div class="settingWrapper">
    <div class="setting flex-row flex-even">
      <p class="part-name">
        <span>{{ $t('PEER.FileSetting.numberOfQuestions') }}</span> {{ options.columns.length - 1 }}
      </p>
      <p class="part-name">
        <span>{{ $t('PEER.FileSetting.numberOfResponses') }}</span>
        {{ numberOfStudent }}
      </p>
      <div class="flex-row flex-center">
        <p class="part-name">
          <span>{{ $t('PEER.FileSetting.numberOfGrading') }}</span>
        </p>
        <select @change="(event) => AC_SET_NUMBER_OF_EVALUATION(parseInt(event.target.value))">
          <option
            v-for="num in numberOfStudent - 1"
            :key="num"
            :selected="num + 1 === numberOfStudent"
          >
            {{ num }}
          </option>
        </select>
      </div>
      <div class="flex-row flex-center">
        <p class="part-name">
          <span>{{ $t('PEER.FileSetting.name') }}</span>
        </p>
        <input type="text" name="paperName" @input="(event) => setPaperTitle(event.target.value)" />
      </div>
    </div>
    <TabulatorComponent v-model="data" :options="options" />
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FileSetting',
  components: {
    TabulatorComponent,
  },
  data() {
    return {
      timer: null,
      data: [],
      options: {
        columns: [],
      },
    };
  },
  methods: {
    ...mapActions('peerPaper', [
      'AC_ABLE_TO_MOVE_NEXT',
      'AC_SET_PAPER_TITLE',
      'AC_SET_PAPER_QUESTION',
      'AC_SET_NUMBER_OF_EVALUATION',
      'AC_SET_NUMBER_OF_STUDENT',
    ]),
    setColumns(data) {
      const colArr = data.data[0].data[0];
      const newOptions = [];
      colArr.forEach((column, index) => {
        newOptions.push({
          title: column,
          field: column,
          sorter: 'string',
          width: `${100 / colArr.length}%`,
          editor: false,
          headerSort: false,
        });
      });
      this.options.columns = newOptions;
    },
    setPaperTitle(value) {
      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.AC_SET_PAPER_TITLE(value);
        this.AC_ABLE_TO_MOVE_NEXT();
      }, 200);
    },
    setTableData(paperData) {
      const colArr = paperData.data[0].data[0];
      const excelData = paperData.data[0].data;

      this.AC_SET_NUMBER_OF_STUDENT(excelData.length - 1);
      this.AC_SET_NUMBER_OF_EVALUATION(excelData.length - 2);

      excelData.slice(1, excelData.length).forEach((rowData, index) => {
        const newRow = {
          '#': index + 1,
        };
        colArr.map((col, index) => {
          newRow[colArr[index]] = rowData[index];

          if (index) {
            let payload = {
              index: colArr[index],
              email: rowData[0],
              answer: rowData[index],
            };
            this.AC_SET_PAPER_QUESTION(payload);
          }
        });
        this.data.push(newRow);
      });
    },
  },
  computed: {
    ...mapState('peerPaper', {
      paperOriginData: (state) => state.paperOriginData,
      numberOfEvaluations: (state) => state.numberOfEvaluations,
      numberOfStudent: (state) => state.numberOfStudent,
    }),
  },
  created() {
    this.setColumns(this.paperOriginData);
    this.setTableData(this.paperOriginData);
  },
};
</script>

<style lang="scss" scoped>
.settingWrapper {
  .setting {
    margin: 15px 0;
    padding: 10px 0;
    border: 2px solid $MAIN-COLOR;
    border-radius: 10px;

    input {
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 1rem;
    }
  }
}
select {
  padding: 5px 10px;
}
.part-name {
  margin-right: 10px;
  span {
    font-weight: bold;
  }
}
</style>
